import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import TeamEndScore from './teamEndScore';
import TeamFinalScore from './teamFinalScore';
import GameControl from '../gameControls/gameControl';
import ScoreControl from '../gameControls/scoreControl';
import PlayoffScoreControl from '../gameControls/playoffScoreControl';
import { GameStatus } from '../../../constants/gameConstants';
import GameControlSecondary from '../gameControls/gameControlSecondary';
import { useAuth } from '../../../contexts/authContext';
import GameControlHorizontal from '../gameControls/gameControlHorizontal';

const TableScoringDisplay = ({ game }) => {
  const { authenticated } = useAuth();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return game && game.teams ? (
    <>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={'space-evenly'}
        alignItems={'center'}
        gap={1}>
        <Box display="flex" flexDirection={isMobile ? 'column-reverse' : 'row'} alignItems="center">
          {authenticated ? (
            game.status === GameStatus.PLAYOFF && game.playoff ? (
              <PlayoffScoreControl game={game} team={game.teams.teamA} />
            ) : (
              <ScoreControl team={game.teams.teamA} game={game} />
            )
          ) : null}
          {game.status === GameStatus.COMPLETE ? (
            <TeamFinalScore team={game.teams.teamA} game={game} />
          ) : (
            <TeamEndScore team={game.teams.teamA} game={game} />
          )}
        </Box>

        {!isMobile && <GameControl game={game} />}

        <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} alignItems="center">
          {game.status === GameStatus.COMPLETE ? (
            <TeamFinalScore team={game.teams.teamB} game={game} />
          ) : (
            <TeamEndScore team={game.teams.teamB} game={game} />
          )}
          {authenticated ? (
            game.status === GameStatus.PLAYOFF && game.playoff ? (
              <PlayoffScoreControl game={game} team={game.teams.teamB} />
            ) : (
              <ScoreControl team={game.teams.teamB} game={game} />
            )
          ) : null}
        </Box>
      </Box>

      {isMobile && <GameControlHorizontal game={game} />}

      {authenticated ? <GameControlSecondary game={game} /> : null}
    </>
  ) : null;
};

export default TableScoringDisplay;
